import { render, staticRenderFns } from "./EcoScoreArvTable.vue?vue&type=template&id=fc1972a0&scoped=true&"
import script from "./EcoScoreArvTable.vue?vue&type=script&lang=js&"
export * from "./EcoScoreArvTable.vue?vue&type=script&lang=js&"
import style0 from "./EcoScoreArvTable.vue?vue&type=style&index=0&id=fc1972a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1972a0",
  null
  
)

/* custom blocks */
import block0 from "./EcoScoreArvTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports